<div class="input-group fn-l-span">
  <input class="form-control" (click)="picker.open()"  [readonly]="isDisable" [placeholder]="placeHolder" [(ngModel)]="uiDate" (change)="changeDate($event)">
  <input matInput [matDatepicker]="picker" style="visibility:hidden;position: absolute;" (dateChange)="setDate()" [min]="globalConfig.minDate" [matDatepickerFilter]="datePickerFilter" [readonly]="isDisable" [placeholder]="placeHolder"  [(ngModel)]="selectedDate">
  @if (isShowIcon) {
    <span class="input-group-text"> <i class="fn-global-calendar cursor-pointer" (click)="picker.open()"></i></span>
  }
</div>

<mat-datepicker #picker [startView]="startView" [panelClass]="customClass" (monthSelected)="_monthSelectedHandler($event,picker)"></mat-datepicker>
